import { Observable } from 'rxjs';
import { PersonalInformation } from '../models/personal-information.model';
import {
    GetReservationParams,
    ReservationResponse,
} from '../models/reservation-response';

export abstract class ReservationRepository {
    abstract saveReservation(): Observable<boolean>;
    abstract clearReservation(): Observable<boolean>;
    abstract restoreReservation(): Observable<any>;
    abstract updateReservation(reservartion: any): Observable<boolean>;
    abstract doReservation(
        personalInformation: PersonalInformation,
    ): Observable<any>;
    abstract getReservation(
        params: GetReservationParams,
    ): Observable<ReservationResponse>;
}
